module.exports = __webpack_public_path__ + "static/media/ProductsIcons.c4834c3e.svg";